import styled from 'styled-components';
import { LauncherElementData, useLauncherElementsStore } from '../../../../hooks/stores/launcherElementsStore';
import { launcherElementInfo } from '../../../../info/launcherElementInfo';
import { IconButton } from '../../IconButton';
import { TextButton } from '../../TextButton';
import { DropdownInput } from '../../baseInputs/DropdownInput';
import { TextInput } from '../../baseInputs/TextInput';
import { useScene } from '../../../../context/sceneContext';

export const CommandVariableInput = () => {
  const scene = useScene();
  const [launcherElementsData] = useLauncherElementsStore<Record<string, LauncherElementData>>();
  const { commands } = scene.getSelectedElementsData({ commands: undefined }, 'props') as LauncherElementData['props'];

  const commandsInfo = launcherElementInfo.button.commands;
  const commandOptions = commandsInfo
    ? Object.keys(commandsInfo).map((command) => ({
        label: commandsInfo[command],
        value: command,
      }))
    : [];

  const popupCommandOptions = Object.entries(launcherElementsData)
    .filter(([id, element]) => element.type === 'popup')
    .map(([id, element]) => ({
      label: element.name || '< no name >',
      value: id,
    }));

  return (
    <>
      {commands?.map(
        (command, index) =>
          command && (
            <Item key={command.type + '-' + index}>
              <Row>
                <DropdownInput
                  label="Command"
                  value={command.type || ''}
                  options={commandOptions}
                  onChange={(newValue) => {
                    const newCommands = [...commands];
                    newCommands[index] = { type: String(newValue) };
                    scene.updateSelectedElementsData({ commands: newCommands }, 'props', 'commandVariableInput');
                  }}
                  canBeCleared={false}
                />

                {commands.length > 1 && (
                  <IconButton
                    iconClassName="icon-x"
                    onClick={() => {
                      const newCommands = [...commands];
                      newCommands.splice(index, 1);
                      scene.updateSelectedElementsData({ commands: newCommands }, 'props', 'commandVariableInput');
                    }}
                    iconSize={12}
                  />
                )}
              </Row>

              {command.type === 'openExternalLinkCommand' && (
                <TextInput
                  label="Url"
                  value={command.linkUrl || ''}
                  onChange={(newValue) => {
                    const newCommands = [...commands];
                    newCommands[index] = { ...newCommands[index], linkUrl: newValue };
                    scene.updateSelectedElementsData({ commands: newCommands }, 'props', 'commandVariableInput');
                  }}
                />
              )}
              {command.type === 'startAppCommand' && (
                <TextInput
                  label="Args"
                  value={command.appProcessExtraArgsAsText || ''}
                  onChange={(newValue) => {
                    const newCommands = [...commands];
                    newCommands[index] = { ...newCommands[index], appProcessExtraArgsAsText: newValue };
                    scene.updateSelectedElementsData({ commands: newCommands }, 'props', 'commandVariableInput');
                  }}
                />
              )}
              {(command.type === 'openPopupCommand' ||
                command.type === 'closePopupCommand' ||
                command.type === 'togglePopupCommand') && (
                <DropdownInput
                  label="Popup"
                  value={command.popupId || ''}
                  options={popupCommandOptions}
                  onChange={(newValue) => {
                    const newCommands = [...commands];
                    newCommands[index] = { ...newCommands[index], popupId: String(newValue) };
                    scene.updateSelectedElementsData({ commands: newCommands }, 'props', 'commandVariableInput');
                  }}
                  canBeCleared={false}
                />
              )}
            </Item>
          )
      )}
      <TextButton
        onClick={() => {
          scene.updateSelectedElementsData(
            { commands: [...(commands || []), { type: 'startAppCommand' }] },
            'props',
            'commandVariableInput'
          );
        }}
      >
        <i className="icon-plus" /> Add Command
      </TextButton>
    </>
  );
};

const Item = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 5px;

  border-radius: var(--radius-2);
  border: 1px solid var(--neutral-3);
`;

const Row = styled.div`
  width: 100%;
  display: flex;
  gap: 2px;
`;
